<template>
  <div class="c-container c-container--dark js-container">
    <div class="u-container">
      <div class="c-container__inner">
        <!-- Begin content -->
        <div class="c-container__icons">
          <div
            v-for="icon in icons"
            :key="icon.icon"
            class="c-container__icon-container"
          >
            <div
              :class="icon.iconTitle"
              class="c-container__icon"
            >
              <icon-base
                :width="64"
                :height="64"
                :view-box="'0 0 64 64'"
                :icon-name="icon.iconTitle"
              >
                <component :is="icon.icon" />
              </icon-base>
            </div>
          </div>
        </div>
        <h1 class="c-container__title">
          {{ json.title }}
        </h1>
        <!-- Page builder components -->
        <section
          v-for="(component, index) in json.components"
          :key="index"
          :class="component.type.toLowerCase()"
        >
          <component
            :is="component.type"
            :component="component"
          />
        </section>
        <!-- Navigation to next component -->
        <div
          v-if="country"
          class="c-container__button-container"
        >
          <!-- Continue without resetting state. -->
          <router-link
            to="/introduction"
            class="c-container__button c-container__button--dark"
            @click.native="scrollToTop"
          >
            Continue
          </router-link>
          <!-- Start again, reset the state. -->
          <a
            class="c-container__button c-container__button--dark"
            @click.prevent="startOver"
            @keyup.prevent="startOver"
          >
            Start over
          </a>
        </div>
        <div
          v-else
          class="c-container__button-container"
        >
          <!-- Default begin button. -->
          <router-link
            to="/introduction"
            class="c-container__button c-container__button--dark"
            @click.native="scrollToTop"
          >
            Begin
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Pym.js embed.
import pymChild from '../embed/index';

// Import all components.
import ContentComponent from '../components/ContentComponent.vue';

// Import svgs
import IconBase from '../components/IconBase.vue';
import IconRifle from '../components/icons/IconRifle.vue';
import IconShop from '../components/icons/IconShop.vue';
import IconRadioactive from '../components/icons/IconRadioactive.vue';
import IconEmbassy from '../components/icons/IconEmbassy.vue';
import IconComputer from '../components/icons/IconComputer.vue';

// Import the json for this component.
const jsonConfig = require('../assets/content/welcome.json');

export default {
  components: {

    // Make all components available, must be lowerCamel.
    contentComponent: ContentComponent,
    IconBase,
    IconRifle,
    IconShop,
    IconRadioactive,
    IconComputer,
    IconEmbassy,
  },
  data() {
    return {

      // The JSON file as a JS array.
      json: jsonConfig,
      icons: [
        {
          icon: 'icon-embassy',
          width: 32,
          height: 37,
          viewBox: '0 0 32 37',
          iconTitle: 'embassy',
        },
        {
          icon: 'icon-radioactive',
          width: 47,
          height: 42,
          viewBox: '0 0 47 42',
          iconTitle: 'radioactive',
        },
        {
          icon: 'icon-computer',
          width: 41,
          height: 32,
          viewBox: '0 0 41 32',
          iconTitle: 'computer',
        },
        {
          icon: 'icon-rifle',
          width: 33,
          height: 38,
          viewBox: '0 0 33 38',
          iconTitle: 'rifle',
        },
        {
          icon: 'icon-shop',
          width: 40,
          height: 31,
          viewBox: '0 0 40 31',
          iconTitle: 'shop',
        },
      ],
    };
  },
  computed: {

    // Lowercase class for modifier automated from component type.
    setClass(type) {
      return type.toLowerCase().trim();
    },

    // Get country value from store.
    country: {
      get() {
        return this.$store.getters.country;
      },
    },
  },
  mounted: () => {
    pymChild.sendHeight();
  },
  updated: () => {
    pymChild.sendHeight();
  },
  methods: {
    startOver() {
      this.$store.dispatch('resetState');
      this.$router.push('/introduction');
    },
    scrollToTop() {
      document.getElementsByClassName('js-container')[0].scrollIntoView();
      pymChild.scrollParentToChildPos(-72);
    },
  },
};
</script>
